import { Stack, usePathname } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";

export default function LocationsLayout() {
  const pathName = usePathname();
  const screenName = pathName.includes("add")
    ? "Create new location"
    : "Locations";

  return (
    <PageLayout
      screenName={screenName}
      titleClassName="text-primary-800"
      headerClassName="mx-dashboard"
      className="py-dashboard"
    >
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: "white" },
        }}
      />
    </PageLayout>
  );
}
